/* eslint-disable radix */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Flex,
  Stack,
  Text,
  Textarea,
  useBreakpointValue
} from '@chakra-ui/react'
import React, { useState } from 'react'

import { SubmitHandler, useForm } from 'react-hook-form'

import { useTranslation } from 'react-i18next'

import { ArrowBack } from '../../components/atoms/arrowBack'
import { Input } from '../../components/Form/Input'
import { Header } from '../../components/Header'
import { CardContainer } from '../../components/molecules/CardContainer'
import { Draft } from '../../components/molecules/Draft'
import { Sidebar } from '../../components/Sidebar'

import { SelectComponent } from '../../components/Form/SelectComponent'
import { Switch } from '../../components/Form/Switch'
import { useAttendance } from './service'

type FormData = {
  is_active: boolean
  description: string
  is_special: boolean
}

type Actions = {
  label: string
  value: string
}

type Specialist = {
  label: string
  value: number
}

type SpecialistData = Array<Specialist>

export function CreateRecipe() {
  const [t] = useTranslation('pageRecipe')
  const attendanceService = useAttendance()
  const { register, handleSubmit, formState } = useForm<FormData>({})
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  })
  const { errors } = formState
  const optionsDefaultActions = [
    {
      value: '1',
      label: `${t('status.1')}`
    },
    {
      value: '2',
      label: `${t('status.2')}`
    }
  ]
  const optionsDefaultRecipes = [
    {
      value: '1',
      label: `${t('recipes.1')}`
    },
    {
      value: '2',
      label: `${t('recipes.2')}`
    }
  ]
  // state
  const [name, setName] = useState('')
  const [valueDraft, setValueDraft] = useState<any>()
  const [specialists, setSpecialists] = useState<SpecialistData>([])
  const [actions, setActions] = useState<Actions>({
    value: '1',
    label: `${t('status.1')}`
  })
  const [recipesType, setRecipesType] = useState<Actions>({
    value: '1',
    label: `${t('recipes.1')}`
  })

  const handleKeyUpEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
    const values = event.target.value.toUpperCase()
    setName(values)
  }

  const handleSelectAction = (event: any) => {
    setActions(event)
  }

  const handleSelectRecipesType = (event: any) => {
    setRecipesType(event)
  }

  const handlerSelectSpecialist = (event: any) => {
    setSpecialists(event)
  }

  // format users specialist for preferences body
  const returnUsersSpecialist = () => {
    const users = specialists.map((user) => {
      return {
        id: user.value,
        name: user.label
      }
    })

    return users
  }

  console.log(valueDraft)

  const handleCreateRecipe: SubmitHandler<FormData> = async (values) => {
    await new Promise((resolve) => setTimeout(resolve, 2000))
    const { is_active, description } = values

    const users = returnUsersSpecialist()

    const payload = {
      name,
      is_active,
      description: description === '' ? null : description,
      users,
      status: Number(actions.value),
      type: Number(recipesType?.value),
      prescription_detail: valueDraft === undefined ? '<p><br><p>' : valueDraft
    }

    attendanceService.createRecipe(payload)
  }

  return (
    <Box overflow="hidden" position="relative">
      <Header>
        <Flex
          mx="auto"
          w="100%"
          direction="row"
          d="flex"
          my="6"
          align="center"
          justify="space-around"
        >
          <Box mx="auto">
            <Text fontSize="24px" fontWeight="600" height="100%">
              {t('create.title')}
            </Text>
          </Box>
          <Stack direction="row" align="center" justify="center">
            <ArrowBack href="/settings/recipes">
              <Text fontSize="md" fontWeight="bold">
                Voltar
              </Text>
            </ArrowBack>
          </Stack>
        </Flex>
      </Header>
      <Sidebar />
      <Flex
        flex="1"
        mx="auto"
        as="form"
        ml={isWideVersion ? '75px' : '2'}
        mt="15px"
        mb="8px"
        mr="2"
        bg="white"
        h="cal(100vh - 60px)"
        onSubmit={handleSubmit(handleCreateRecipe)}
      >
        <Stack spacing="4" w="100%">
          <CardContainer title={t('create.container1.title')}>
            <Stack direction="row" my="2" spacing="6">
              <Box w="50%" mr="2">
                <Input
                  label={t('create.container1.i1')}
                  name="name"
                  fontSize="16"
                  placeholder={t('placeholder.name')}
                  isRequired
                  value={name}
                  onChange={handleKeyUpEvent}
                  maxLength={30}
                />
              </Box>
              <Stack direction="row" my="2" spacing="4" w="50%">
                <Box w="300px" mr="2">
                  <SelectComponent
                    options={optionsDefaultRecipes}
                    name="recipesType"
                    value={recipesType}
                    onChange={handleSelectRecipesType}
                    title={t('label.recipes')}
                    placeholder={t('placeholder.recipes')}
                  />
                </Box>
                <Box w="300px" mr="2">
                  <SelectComponent
                    options={optionsDefaultActions}
                    name="status"
                    value={actions}
                    onChange={handleSelectAction}
                    title={t('label.status')}
                    placeholder={t('placeholder.status')}
                  />
                </Box>
                <Box ml="12">
                  <Switch
                    defaultChecked
                    label={t('create.container1.i2')}
                    {...register('is_active')}
                  />
                </Box>
              </Stack>
            </Stack>
            <Flex direction="column">
              <Text mb="2" fontSize="sm">
                {t('create.container1.i5')}
              </Text>
              <Textarea
                placeholder={t('create.container1.description')}
                {...register('description')}
                maxLength={200}
              />
            </Flex>
          </CardContainer>

          <CardContainer title={t('create.container2.title')}>
            <Stack direction="column" my="2" spacing="6" w="100%">
              <SelectComponent
                options={
                  attendanceService.specialists?.length &&
                  attendanceService.specialists.map((specialist) => {
                    return {
                      value: specialist?.user?.id,
                      label: specialist?.social_name || specialist?.user?.name
                    }
                  })
                }
                value={specialists}
                title={t('create.container2.i1')}
                isMulti
                onChange={handlerSelectSpecialist}
                name="specialists"
                placeholder={t('create.container2.specialist')}
              />
            </Stack>
          </CardContainer>

          <CardContainer title={t('create.container3.title')}>
            <Draft
              getValue={(value: any) => {
                setValueDraft(value)
              }}
            />
          </CardContainer>

          <Flex mt="6" w="100%" align="flex-end" justifyContent="flex-end">
            <Button
              type="submit"
              size="md"
              fontSize="md"
              bg="blue.300"
              color="#fff"
              isLoading={formState.isSubmitting}
            >
              {t('create.button')}
            </Button>
          </Flex>
        </Stack>
      </Flex>
    </Box>
  )
}
